import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { size as psize } from 'polished';
import { space, SpaceProps } from 'styled-system';
interface Props extends SpaceProps {
  size: number;
  isCPU?: boolean | null;
}

const ProfileImage = ({ size, isCPU, ...others }: Props) => (
  <Img
    {...others}
    css={css`
      ${psize(`${size}px`)}
      background-color: white;
      padding: 1px;
      border-radius: 50%;
    `}
    src={
      isCPU
        ? require('./cpu.png').default
        : require('./profile-user.svg').default
    }
    alt=""
  />
);

export default ProfileImage;

const Img = styled('img')(space);
